import { render, staticRenderFns } from "./fivePage.vue?vue&type=template&id=7a0b0e9e&scoped=true&"
import script from "./fivePage.vue?vue&type=script&lang=js&"
export * from "./fivePage.vue?vue&type=script&lang=js&"
import style0 from "./fivePage.vue?vue&type=style&index=0&id=7a0b0e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0b0e9e",
  null
  
)

export default component.exports